import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';

const StyledAmountLineContainer = styled(Grid)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(3),
}));

export default StyledAmountLineContainer;
